module.exports = __webpack_public_path__ + "img/shop-similar-camera-24.002a7da.svg";